import { CategoryData } from "../../categories/interfaces/dto";

declare var pm: PmInterface;

export function buildTrendingCategoriesOutput(
	categories: CategoryData[],
	trendingCategoriesResultWrapper: HTMLElement,
	trendingCategoryItemToClone: HTMLElement,
) {
	if (!trendingCategoryItemToClone) return;

	if (trendingCategoriesResultWrapper) {
		pm.utils.dom.emptyElement(trendingCategoriesResultWrapper);
	}

	const fragment = new DocumentFragment();

	categories.forEach(function (category) {
		const categoryItem = trendingCategoryItemToClone.cloneNode(
			true,
		) as HTMLElement;
		const link: HTMLAnchorElement | null =
			categoryItem.querySelector(".category-name");

		if (link) {
			link.href = category.url;
			link.textContent = category.name;
		}

		fragment.appendChild(categoryItem);
	});

	const viewAllItem = trendingCategoryItemToClone.cloneNode(
		true,
	) as HTMLElement;

	if (viewAllItem) {
		const viewAlllink: HTMLAnchorElement | null = viewAllItem
			? viewAllItem.querySelector(".category-name")
			: null;

		if (viewAlllink) {
			viewAlllink.href = pm.siteUrl + "/categories/";
			viewAlllink.textContent = "View all categories";
		}

		fragment.appendChild(viewAllItem);
	}

	if (trendingCategoriesResultWrapper) {
		trendingCategoriesResultWrapper.appendChild(fragment);
	}
}
